define([
  "jquery",
  "underscore",
  "marionette",
  "google_analytics",
  "forms/deposit/deposit_currency_market_form",
  "behaviors/form_errors_behavior",
  "backbone.syphon",
  "holdon"
], function($, _, Marionette, GoogleAnalytics, CurrencyMarketForm, FormErrorsBehavior) {

  return Marionette.View.extend({
    el: '#content_layout',
    behaviors: {
      formErrors: {
        behaviorClass: FormErrorsBehavior
      },
    },
    ui: {
      mtAccounts: '#mt4_account_no',
      failureMsg: '#failure_msg',
      failureMsgText: '#failure_msg_text',

      usdtEa : '#usdt_ea',

      depositMoney : '#deposit_money',

      userEwallet : '#user_ewallet',

      depositBtn: "#deposit_btn",
      hold_on_overlay: '#holdon-overlay',
    },

    events: {
      'change @ui.mtAccounts': 'refreshDepositDatas',

      'keyup @ui.depositMoney': 'updateExpectedUsdAndUsdt',
      'click @ui.depositBtn': 'deposit',
    },

    /**
     * Fetch or generate USDT Wallet deposit address
     */
    initialize: function () {
      this.bindUIElements();
      this.refreshDepositDatas();

      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'manual'
      });
    },

    refreshDepositDatas: function () {
      this.getDepositAddress();
    },

    getDepositAddress: function () {
      var that = this;

      HoldOn.open({
        message: "Reading USDT Wallet address ...",
        theme: "sk-fading-circle"
      });

      var selectedIndex = this.ui.mtAccounts[0].selectedIndex;

      $.ajax('/rest_crypto/get_deposit_address', {
        data: {
          crypto: 'TRON_USDT',
          mt_account: this.ui.mtAccounts[0][selectedIndex].value,
        },

        success: function (data) {
          that.ui.userEwallet.val(data.address);

          HoldOn.close();
          that.ui.failureMsg.hide();
        },

        error: function (error) {
          HoldOn.close();
          that.ui.failureMsg.show();
          that.ui.failureMsgText.text(error.responseJSON.error);
        }
      })
    },

    deposit: function(e) {
      e.preventDefault();
      this.triggerMethod('hide:errors');

      HoldOn.open({
        message: "Deposit requesting ...",
        theme: "sk-fading-circle"
      });

      const formData = Backbone.Syphon.serialize(this.$('#form_submit')[0]);
      const form = new CurrencyMarketForm();
      form.set(formData);
      const errors = form.validate();

      let that = this;

      if(_.size(errors) < 1){
        form.validateWithServer({
          type: 'POST',
          success: function(model, res){
            that.triggerMethod('show:success');
            that.$('#form_submit').submit();
            HoldOn.close();
          },

          error: function(model, error){
            that.triggerMethod('show:errors', error.responseJSON);
            HoldOn.close();
          }
        });
      }else{
        this.triggerMethod('show:errors', errors);
        HoldOn.close();
      }
    },

    updateExpectedUsdAndUsdt: function(e) {
      e.preventDefault();

      const usdt_rate = window.usdt_rate;
      if (isNaN(usdt_rate) || usdt_rate === '' || !usdt_rate) {
        $('#expected_amount').val('-');
        return;
      }

      const inUsd = ($(this.ui.depositMoney).val() / usdt_rate).toFixed(2);
      $('#expected_amount').text('$ ' + inUsd);
      $(this.ui.usdtEa).val(Number(inUsd));
    },
  });
});
